import React from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BladeHeader, BladeHeaderHeading, BladeHeaderSupertitle, BladeHeaderTitle, BladeHeaderSubtitle, BladeHeaderBody, } from "../../../components/BladeHeader";
import { BladeContent } from "../../../components/BladeContent";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { MastheadBladeSchema } from "../../../schemas/blades/Masthead";
import { z } from "zod";
import { RichText } from "../../../components/RichText";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { CTA } from "../../../components/CTA";
export const MediaMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal("mediaMasthead"),
});
const _MediaMasthead = ({ header = {}, backdrop, className, ...bladeProps }) => {
    const headerContent = hasVisibleContent(header);
    const { background, foreground } = backdrop || {};
    const { title, supertitle, subtitle, description, links } = header;
    return (React.createElement(Blade, { "data-testid": "mediaMasthead", className: `${className} ${!foreground && " no-foreground"}`, ...bladeProps },
        React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background && React.createElement(Media, { media: background, autoPlay: true, muted: true, role: "presentation" }))),
        React.createElement(BladeContent, { width: "large" },
            headerContent && (React.createElement(BladeHeader, null,
                React.createElement(BladeHeaderHeading, null,
                    supertitle && React.createElement(BladeHeaderSupertitle, null, supertitle),
                    title && (React.createElement(BladeHeaderTitle, null,
                        React.createElement("h1", null, title))),
                    subtitle && React.createElement(BladeHeaderSubtitle, null, subtitle)),
                description ? (React.createElement(BladeHeaderBody, null,
                    React.createElement(RichText, { ...description }))) : null,
                links ? (React.createElement("div", { className: "links" },
                    links?.[0] && React.createElement(CTA, { variant: "primary", ...links[0] }),
                    links?.[1] && React.createElement(CTA, { variant: "secondary", ...links[1] }))) : null)),
            React.createElement(Backdrop, null,
                React.createElement(BackdropForeground, null, foreground && React.createElement(Media, { media: foreground, autoPlay: true, muted: true }))))));
};
export const MediaMasthead = styled(_MediaMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=MediaMasthead.js.map